import { useQuery } from "react-query";
import { MdmsService } from "../../services/elements/MDMS";

const useMDMSV2 = (tenantId, moduleCode, type, config = {}, payload = []) => {
  console.log("insideV2MDMScall", { tenantId, moduleCode, type, config });

  const queryConfig = { staleTime: Infinity, ...config };
  const useDocumentMapping = () => {
    return useQuery("DOCUMENT_MAPPING", () => MdmsService.getDocumentTypes(tenantId, moduleCode, type), queryConfig);
  };
  const useTradeTypetoRoleMapping = () => {
    return useQuery("ROLE_DOCUMENT_MAPPING", () => MdmsService.getTradeTypeRoleTypes(tenantId, moduleCode, type), queryConfig);
  };
  const useMSTypeDropDownMapping = () => {
    return useQuery("MAP_SUBMISSION_MAPPING", () => MdmsService.getMSDropDownTypes(tenantId, moduleCode, type), queryConfig);
  };
  const useLandUseCategoriesMapping = () => {
    return useQuery("LAND_USE_MAPPING", () => MdmsService.getLandUseCategories(tenantId, moduleCode, type), queryConfig);
  };
  const _default = () => {
    return useQuery([tenantId, moduleCode, type], () => MdmsService.getMultipleTypesV2(tenantId, moduleCode, type), config);
  };

  switch (type) {
    case "DocumentTypes":
      return useDocumentMapping();
    case "TradeTypetoRoleMapping":
      return useTradeTypetoRoleMapping();
    case "DropdownsConfig":
      return useMSTypeDropDownMapping();
    case "BasicFarPurchasable":
      return useLandUseCategoriesMapping();
    default:
      return _default();
  }
};

export default useMDMSV2;
